<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="3"></left-panel>

    </div>
    <div class="post-login-2-col-2" *ngIf="this.loanDetail?.length > 0">
        <div>

            <ng-container *ngIf="this.serviceType === 'Islamic'">
                <div class="font-600 font-size-20px line-h-40 color-base-1700" *ngIf="this.serviceType === 'Islamic'">
                    {{"myfinance" | translate }}
                </div>

                <div class="card-slider mt-10 p-10">
                    <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                        <ng-template carouselSlide *ngFor="let item of this.loanDetail; let i = index">
                            <div class="card" [ngClass]="selectedCard == i ? 'active' : ''">
                                <!-- *ngIf="item.activationFlag == 'N'" (click)="activateCard()" -->
                                <!-- <span class="active-text-box">
                                    {{"ViewFinanceDetails" | translate}}
                                </span> -->
                                <div class="img-box">
                                    <!-- <img src="~/../assets/images/L25.png" alt=""> -->
                                    <img [src]="'~/../assets/images/'+item?.productCode+'.png'" alt="">

                                    <div class="text-box">
                                        <grid-row class="justify-content-between align-item-top">
                                            <grid-col class="text-align-right" col="12">
                                                <span
                                                    class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2 font-400 font-size-12px color-base-700"
                                                    *ngIf="item.loanNickName">
                                                    <!-- {{"LoanNickname" | translate}} -->
                                                    {{item?.loanNickName}}
                                                </span>
                                            </grid-col>
                                            <grid-col col="12">
                                                <div
                                                    class="font-400 font-size-14px line-h-20 letter-spacing-1 color-base-700 text-uppercase mt-10">
                                                    <!-- {{"VehicleLoanApr" | translate}} -->
                                                    {{item?.productDescription}}
                                                </div>
                                            </grid-col>

                                        </grid-row>
                                        <div
                                            class="font-500 font-size-14px line-h-20 mt-10 letter-spacing-2 opacity-08 color-base-700">
                                            {{item?.loanId}}
                                        </div>
                                        <div
                                            class="font-400 font-size-12px line-h-14 color-base-700 letter-spacing-1 mt-10 text-uppercase">
                                            {{"OutstandingBalance" | translate }}
                                        </div>
                                        <div class="font-size-16px color-base-700">
                                            <span class="line-h-25 font-600">
                                                <!-- {{"BHD" | translate }} -->
                                                {{item?.accountCurrencyISO}}
                                            </span>
                                            <span class="line-h-25 font-600">
                                                {{item?.outstandingAmount}}
                                            </span>
                                        </div>
                                        <grid-row class="justify-content-between align-item-center">
                                            <grid-col col="9">
                                                <!-- percentage rate -->
                                                <custom-progress-bar [barCounter]="false" [currentValue]="progressValue"
                                                    smallBar="true" width="w-100">
                                                </custom-progress-bar>
                                            </grid-col>
                                            <grid-col col="auto">
                                                <div class="bg-base-100 p-5 br-100"
                                                    *ngIf="item?.productDescription=='Vehicle Loans - APR'">
                                                    <ng-icon iconClass="icon-card-car" width="30" height="30"></ng-icon>
                                                </div>
                                                <div class="bg-base-100 p-5 br-100"
                                                    *ngIf="item?.productDescription !='Vehicle Loans - APR'">
                                                    <ng-icon iconClass="icon-islamic-car-loan" width="30"
                                                        height="30"></ng-icon>
                                                </div>


                                            </grid-col>
                                        </grid-row>
                                        <span class="font-400 font-size-10px line-h-14 mr-10 color-base-700">
                                            {{"YourPaymentDueOn"| translate}}
                                        </span>
                                        <span class="font-600 font-size-10px line-h-14 color-base-700">
                                            <!-- {{this.commonP.StringToDate(item?.nextDueDate)| date: "MM/yy"}} -->
                                             {{ this.commonP.StringToDate(item?.nextDueDate) | date: 'yyyy-MM-dd' }}
                                             <!-- {{item?.nextDueDate| date: "MM/YY"}} -->
                                              
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </ng-container>

            <div class="font-600 font-size-20px line-h-40 color-base-1700" *ngIf="this.serviceType === 'Conventional'">
                {{"MyLoan" | translate }}
            </div>


             <div class="card-slider mt-10 p-10">
                    <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                        <ng-template carouselSlide *ngFor="let item of this.loanDetail; let i = index">
                             <div class="card" [ngClass]="selectedCard == i ? 'active' : ''">
                            <div class="img-box bg-yellow">
                                <!-- <img src="~/../assets/images/loan-card-bg2.png" alt=""> -->
                                <!-- <img [src]="'~/../assets/images/'+item?.productDescription+'.png'" alt=""> -->

                                <div class="text-box">
                                    <grid-row class="justify-content-between align-item-top">
                                        <grid-col class="text-align-right" col="12">
                                            <span
                                                class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2 font-400 font-size-12px color-base-700"
                                                *ngIf="item.loanNickName">
                                                <!-- {{"LoanNickname" | translate}} -->
                                                {{item?.loanNickName | translate}}
                                            </span>
                                        </grid-col>
                                        <grid-col col="12">
                                            <div
                                                class="font-400 font-size-14px line-h-20 letter-spacing-1 color-base-700 text-uppercase mt-10">
                                                <!-- {{"VehicleLoanApr" | translate}} -->
                                                {{item?.productDescription}}
                                            </div>
                                        </grid-col>

                                    </grid-row>
                                    <div
                                        class="font-500 font-size-14px line-h-20 mt-10 letter-spacing-2 opacity-08 color-base-700">
                                        {{item?.loanId}}
                                    </div>
                                    <div
                                        class="font-400 font-size-12px line-h-14 color-base-700 letter-spacing-1 mt-10 text-uppercase">
                                        {{"OutstandingBalance" | translate }}
                                    </div>
                                    <div class="font-size-16px color-base-700">
                                        <span class="line-h-25 font-600">
                                            <!-- {{"BHD" | translate }} -->
                                            {{item?.accountCurrencyISO}}
                                        </span>
                                        <span class="line-h-25 font-600">
                                            {{item?.outstandingAmount}}
                                        </span>
                                    </div>
                                    <grid-row class="justify-content-between align-item-center">
                                        <grid-col col="9">
                                            <!-- percentage rate -->
                                            <custom-progress-bar [barCounter]="false" [currentValue]="progressValue"
                                                smallBar="true" width="w-100">
                                            </custom-progress-bar>
                                        </grid-col>
                                        <grid-col col="auto">
                                            <div class="bg-base-100 p-5 br-100"
                                                *ngIf="item?.productDescription=='Vehicle Loans - APR'">
                                                <ng-icon iconClass="icon-card-car" width="30" height="30"></ng-icon>
                                            </div>
                                            <div class="bg-base-100 p-5 br-100"
                                                *ngIf="item?.productDescription !='Vehicle Loans - APR'">
                                                <ng-icon iconClass="icon-mortage" width="30" height="30"></ng-icon>
                                            </div>


                                        </grid-col>
                                    </grid-row>
                                    <span class="font-400 font-size-10px line-h-14 mr-10 color-base-700">
                                        {{"YourPaymentDueOn"| translate}}
                                    </span>
                                    <span class="font-600 font-size-10px line-h-14 color-base-700">
                                        <!-- {{this.commonP.StringToDate(item?.nextDueDate)| date: "MM/yy"}} -->
                                         {{ this.commonP.StringToDate(item?.nextDueDate) | date: 'yyyy-MM-dd' }}
                                        <!-- {{item?.nextDueDate| date: "MM/YY"}} -->

                                    </span>
                                </div>
                            </div>
                        </div>
                        </ng-template>
                    </owl-carousel-o>
             </div>


            <!-- <div class="card mt-15" *ngFor="let item of this.loanDetail; let i = index"
                [ngClass]="selectedCard == i ? 'active' : ''" (click)="selectCard(i)">
                <div class="img-box">
                    <img src="~/../assets/images/loan-card-bg2.png" alt="">
                    <div class="text-box">
                        <grid-row class="justify-content-between align-item-top">
                            <grid-col class="text-align-right" col="12">
                                <span class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2 font-400 font-size-12px color-base-1500" *ngIf="item.loanNickName">
                                    {{"LoanNickname" | translate}}
                                    {{item?.loanNickName}}
                                </span>
                            </grid-col>
                            <grid-col col="12">
                                <div class="font-400 font-size-14px line-h-20 letter-spacing-1">
                                    {{"VehicleLoanApr" | translate}}
                                    {{item?.productDescription}}
                                </div>
                            </grid-col>
                          
                        </grid-row>
                        <div class="font-500 font-size-14px line-h-20 mt-10 letter-spacing-2 opacity-08">
                            {{item?.loanId}}
                        </div>
                        <div class="font-400 font-size-12px line-h-14 color-base-400 letter-spacing-1 mt-10">
                            {{"OutstandingBalance" | translate }}
                        </div>
                        <div class="font-600 font-size-16px">
                            <span class="line-h-25">
                                {{"BHD" | translate }}
                                {{item?.accountCurrencyISO}}
                            </span>
                            <span class="line-h-25">
                                {{item?.outstandingAmount}}
                            </span>
                        </div>
                        <grid-row class="justify-content-between align-item-center">
                            <grid-col col="9">
                                <custom-progress-bar [barCounter]="false" currentValue="60" smallBar="true" width="w-100">
                                </custom-progress-bar>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="bg-base-100 p-5 br-100">
                                    <ng-icon iconClass="icon-card-car" width="30" height="30"></ng-icon>
                                </div>
                            </grid-col>
                        </grid-row>
                        <span class="font-400 font-size-10px line-h-14 mr-10">
                            {{"YourPaymentDueOn"| translate}}
                        </span>
                        <span class="font-600 font-size-10px line-h-14">
                            {{this.commonP.StringToDate(item?.nextDueDate)}}
                        </span>
                    </div>
                </div>
            </div> -->
            <div class="font-400 font-size-14px line-h-20 color-base-1200 mt-40"
                *ngIf="this.serviceType === 'Conventional'">
                {{"LoanDetails" | translate }}
            </div>
            <div class="font-400 font-size-14px line-h-20 color-base-1200 mt-40" *ngIf="this.serviceType === 'Islamic'">
                {{"FinanceDetails" | translate }}
            </div>
            <!-- loan fixes yousuf -->
            <div class="bg-base-100 box-shadow border border-color-900 text-align-center br-16 mt-10 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Conventional'">
                            {{"Loantype" | translate}}
                        </div>
                        <div class="font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Islamic'">
                            {{"FinanceType" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            <!-- 10,000.000 -->
                            {{this.selectedLoanDetail?.productDescription}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Conventional'">
                            {{"LoanApplicationNumber" | translate}}
                        </div>
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Islamic'">
                            {{"FinanceApplicationNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.loanId}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"Monthlypsyment" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.installmentAmount | amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <!-- <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"LoanAmount" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.loanAmount}}
                        </div>
                    </grid-col>
                </grid-row> -->
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"nextDueDate" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            <!-- {{this.selectedLoanDetail?.nextDueDate| date: "dd MMM YYYY"}} -->
                            <!-- {{this.commonP.StringToDate(this.selectedLoanDetail?.nextDueDate)|date: "dd MMM YYYY"}} -->
                        {{ this.selectedLoanDetail?.nextDueDate
                        ? (this.commonP.StringToDatePIPE(this.selectedLoanDetail.nextDueDate) | date:'dd MMM yyyy')
                        : '-' }}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"InstallmentDate" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.lastInstallmentDate}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Conventional'">
                            {{"Interestrate" | translate}}
                        </div>
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800"
                            *ngIf="this.serviceType === 'Islamic'">
                            {{"Profitrate" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.loanInterestRate}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"OutstandingBalance" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.outstandingAmount |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24 mb-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"OverdueAmount" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedLoanDetail?.overdueAmount |amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
                <!-- <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"LoanDetails" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500"> 
                          //   5 years - 2.6% p.a -->
                <!-- {{this.LoanYear+' years '+this.LoanMonths+' months'+' -'+this.selectedLoanDetail?.loanInterestRate+'% '+'p.a'}} 
                        </div>
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                          //  5 years - 2.6% p.a 
                            <span class="font-600 font-size-14px line-h-20 color-base-1500">{{this.LoanYear}} {{
                                this.LoanYear > 1 ? ' years ': ' year '}}</span>
                            <span class="font-600 font-size-14px line-h-20 color-base-1500"
                                *ngIf="this.LoanMonths!==0">{{this.LoanMonths}} {{ this.LoanMonths > 1 ? ' months' :'
                                month' }}</span>
                           Ghufran request by jira to remove this +'p.a' in loandetails -->
                <!-- <span class="font-600 font-size-14px line-h-20 color-base-1500">{{' -'+this.selectedLoanDetail?.loanInterestRate+'% '}}</span> -->
                <!-- {{this.LoanYear+' years '+this.LoanMonths+' months'+' -'+this.selectedLoanDetail?.loanInterestRate+'% '+'p.a'}} 
                        </div>
                    </grid-col>
                </grid-row>-->


                <!-- <grid-row class="justify-content-between mt-24 mb-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"AccountDisbursement" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            Account - BHD
                        </div>
                    </grid-col>
                </grid-row> -->

            </div>
            <!-- loan fixes yousuf -->
        </div>
    </div>
    <div class="post-login-2-col-3">
        <div *ngIf="this.loanDetail?.length > 0 && !this.ViewGroupTransaction">
            <div class="font-600 font-size-20px line-h-40 color-base-1700">
                <!-- {{"VehicleLoan" | translate }} -->
                {{this.selectedLoanDetail?.productDescription}}

            </div>
            <div class="font-400 font-size-14px line-h-20 color-base-1200" *ngIf="this.serviceType === 'Conventional'">
                {{"LoanActions" | translate }}
            </div>
            <div class="font-400 font-size-14px line-h-20 color-base-1200" *ngIf="this.serviceType === 'Islamic'">
                {{"FinanceActions" | translate }}
            </div>

            <grid-row class="col-space-min no-wrap  overflow-x-auto mt-16">
                <grid-col col="auto">
                    <div class="card-box-big link" [routerLink]="['/PayCard']"
                        [queryParams]="{ id: this.selectedLoanDetail?.internalId,type:'L', flow:'',max:this.selectedLoanDetail?.maxPaymentAmount }">
                        <div class="icon-box">
                            <!-- <ng-icon iconClass="icon-card-transfer" width="30" height="24"></ng-icon> -->
                            <!-- [queryParams]="{ id: this.selectedLoanDetail?.internalId,type:'L', flow:'Pay' }"> -->

                            <ng-icon iconClass="icon-pay-loan-green" width="30" height="24"></ng-icon>

                        </div>
                        <div class="font-600 font-size-10px line-h-14 p-12" *ngIf="this.serviceType === 'Conventional'">
                            {{ "PayLoan" | translate }}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 p-12" *ngIf="this.serviceType === 'Islamic'">
                            {{ "PayFINANCE" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="card-box-big link" [routerLink]="['/LoanNickname']"
                        [queryParams]="{ id: this.selectedLoanDetail?.internalId,nickName:this.selectedLoanDetail?.loanNickName}">
                        <!-- <ng-icon iconClass="icon-card-nick-name" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-nickname-green" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-12"
                            *ngIf="this.selectedLoanDetail?.loanNickName != ''">
                            {{ "EditNickname" | translate }}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 mt-12"
                            *ngIf="this.selectedLoanDetail?.loanNickName == ''">
                            {{ "AddNickname" | translate }}
                        </div>
                    </div>
                </grid-col>
                <!-- <grid-col col="auto"> -->
                <!-- [ngClass]="this.UnGroupLoanTransactionHistory && this.UnGroupLoanTransactionHistory.length==0 ? 'disabled':''"  -->
                <!-- <div class="card-box-big link"   [routerLink]="['/LoanPaymentHistory']"
                        [queryParams]="{ id: this.selectedLoanDetail?.internalId}">
                                <ng-icon iconClass="icon-card-statement-green" width="26" height="27"></ng-icon>

                        <div class="font-600 font-size-10px line-h-14 mt-12" >
                            {{ "ViewLoanstatement" | translate }}
                        </div>
                    </div> -->
                <!-- </grid-col> -->
                <grid-col col="auto">
                    <!-- (click)="selectMonth()" -->
                    <div class="card-box-big link" [routerLink]="['/LoanPaymentHistory']"
                        [queryParams]="{ id: this.selectedLoanDetail?.internalId,type:'L' }">
                        <ng-icon iconClass="icon-card-statement-green" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 mt-12"
                            *ngIf="this.serviceType === 'Conventional'">
                            {{ "ViewLoanstatement" | translate }}
                        </div>
                        <div class="font-600 font-size-10px line-h-14 mt-12" *ngIf="this.serviceType === 'Islamic'">
                            {{ "ViewFinancestatement" | translate }}
                        </div>
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="card-box-big" (click)="showModal(11,'')" *ngIf="this.serviceType === 'Conventional'">
                        <!-- <ng-icon iconClass="icon-email-blue-sm" width="26" height="26"></ng-icon> -->
                        <ng-icon iconClass="icon-request-supplementary-green" width="26" height="27"></ng-icon>
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "ServiceRequestLetters" | translate }}
                        </div>
                    </div>
                </grid-col>
                <!-- <grid-col col="auto">
                    <div class="card-box-big" (click)="loanDeferInstalment()">
                                <ng-icon iconClass="icon-defer-instalment-green" width="26" height="27"></ng-icon> 
                        <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10">
                            {{ "DeferInstalment" | translate }}
                        </div>
                    </div>
                </grid-col> -->
            </grid-row>

            <!-- <grid-row class="justify-content-between mt-30">
                <grid-col col="auto">
                    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                        {{"PaymentHistory" | translate }}
                    </div>
                </grid-col>
                <grid-col col="auto">  
                    <div class="font-500 font-size-12px line-h-18 color-primary text-align-center letter-spacing-1 link" (click)="this.showModal(7)">
                        {{"ViewMore" | translate}}
                    </div>
                </grid-col>
            </grid-row>
            <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-10 p-16">
                <div class="mt-8">
                    <span class="br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px bg-base-400 color-base-100">
                        {{"VATExempted" | translate}}
                    </span>
                </div>
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1500">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1500">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1500">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
                <div class="mt-24">
                    <span class="br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px bg-base-400 color-base-100">
                        {{"VATExempted" | translate}}
                    </span>
                </div>
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1500">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
                <div class="mt-24">
                    <span class="br-40 pl-8 pr-8 pt-4 pb-4 font-400 font-size-12px bg-base-400 color-base-100">
                        {{"VATExempted" | translate}}
                    </span>
                </div>
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1500">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
            </div>
             -->

            <!-- <grid-row class="justify-content-center p-50 text-align-center">
                <grid-col col="6">
                    <div>
                        <ng-icon iconClass="icon-vehicle-loan" width="58" height="64"></ng-icon>
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-1800 mt-24">
                        {{"NextletsCreate" | translate}}
                    </div>
                </grid-col>
            </grid-row> -->
            <!-- <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-16 p-16">
                <span class="font-400 font-size-10px  bg-base-1900 br-20 color-base-100 pt-5 pb-5 pl-10 pr-10">
                    {{"VATExempted" | translate}}
                </span>
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-21 color-base-1300">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            Today - 8:32PM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,290.540
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-21 color-base-1300">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            19/5 - 11:08AM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,445.540
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-21 color-base-1300">
                            {{"PayLoan" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-success">
                            {{"BHD" | translate}} 155.000
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-7">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            19/4 - 10:28AM
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-12 color-base-1800">
                            {{"BHD" | translate}} 8,600.540
                        </div>
                    </grid-col>
                </grid-row>
            </div> -->

            <grid-row class="justify-content-between mt-30">
                <grid-col col="auto">
                    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                        {{"PaymentHistory" | translate }}
                    </div>
                </grid-col>
                <grid-col col="auto"
                    *ngIf="this.UnGroupLoanTransactionHistory && this.UnGroupLoanTransactionHistory.length > 0">
                    <div class="font-500 font-size-12px line-h-18 color-primary text-align-center letter-spacing-1 link"
                        (click)="onTrasactionsChange()">
                        {{"ViewMore" | translate}}
                    </div>
                </grid-col>
            </grid-row>


            <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-10 p-16"
                *ngIf="this.UnGroupLoanTransactionHistory && this.UnGroupLoanTransactionHistory.length > 0">
                <div *ngFor="let item of this.UnGroupLoanTransactionHistory">
                    <div class="mb-10" *ngIf="item?.vat">
                        <span class="font-400 font-size-12px bg-base-1900 br-20 color-base-100 pt-3 pb-3 pl-13 pr-13">
                            {{item?.vat}}
                        </span>
                    </div>
                    <grid-row class="justify-content-between">
                        <grid-col col="auto">
                            <div class="font-400 font-size-14px line-h-21 color-base-1300">
                                {{item?.transactionDescription}}
                            </div>
                        </grid-col>
                        <grid-col col="auto" *ngIf="item?.debitCreditIndicator=='D'">
                            <div class="font-600 font-size-14px line-h-20 color-black">
                                - {{item?.accountCurrencyISO}} {{item?.transactionAmount|amountFormatter}}
                            </div>
                        </grid-col>
                        <grid-col col="auto" *ngIf="item?.debitCreditIndicator=='C'">
                            <div class="font-600 font-size-14px line-h-20 color-success">
                                {{item?.accountCurrencyISO}} {{item?.transactionAmount|amountFormatter}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-12 color-base-1800">
                                {{item?.transactionDate }}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-12 color-base-1800">
                                {{item?.runningBalance}}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div>
            <!-- ungroup transaction empty state need to apply codition -->
            <grid-row class="justify-content-center align-item-center h-100 mt-50"
                *ngIf="this.UnGroupLoanTransactionHistory && this.UnGroupLoanTransactionHistory?.length==0">
                <grid-col col="4">
                    <div class="text-align-center">
                        <ng-icon iconClass="icon-loan-dashboard-big" width="120" height="120"></ng-icon>
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                        {{"Youhaventmadeanypaymentonyourloan" | translate }}
                    </div>
                </grid-col>
            </grid-row>


        </div>
        <grid-row class="justify-content-between align-item-center" *ngIf="this.ViewGroupTransaction">
            <grid-col col="auto">
                <grid-row class="col-space-min align-item-center">
                    <grid-col col="auto">
                        <!-- <div class="link">
                            <ng-icon iconClass="icon-back-button" width="22" height="22" (click)="back()"></ng-icon>
                        </div> -->
                        <div class="link" (click)="back()">
                            <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                            {{"Transactionhistory" | translate }}
                        </div>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
        <div *ngIf="this.ViewGroupTransaction">
            <ng-container *ngFor="let items of GroupLoanTransactionHistory; let i = index; trackBy: trackByFn">
                <div class="mt-10">
                    <span class="font-400 font-size-14px color-base-1500">{{ items?.label }}</span>
                    <div [ngClass]="items?.label ? 'bg-base-100 box-shadow border border-color-900' : ''"
                        class="br-12 pl-15 pr-15">

                        <grid-row class="justify-content-between align-item-center mb-10 mt-10 link"
                            *ngFor="let item of items.cardTransactions; trackBy: trackByFn"
                            (click)="showModal(10, item)">

                            <grid-col col="auto">
                                <div class="mb-10" *ngIf="item?.vat">
                                    <span
                                        class="font-400 font-size-12px bg-base-1900 br-20 color-base-100 pt-3 pb-3 pl-13 pr-13">
                                        {{ item?.vat }}
                                    </span>
                                </div>

                                <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                    {{ item?.transactionDescription }}
                                </div>

                                <div class="font-400 font-size-12px line-h-12 color-base-1800"
                                    *ngIf="item?.transactionDate">
                                    {{ formatDate(item?.transactionDate) | date: "dd-MM-yyyy hh:mm a" }}
                                </div>
                            </grid-col>

                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-black text-align-right"
                                    *ngIf="item?.debitCreditIndicator === 'D'">
                                    - {{"BHD" | translate}} {{ item?.transactionAmount | amountFormatter }}
                                </div>

                                <div class="font-600 font-size-14px line-h-20 color-success text-align-right"
                                    *ngIf="item?.debitCreditIndicator === 'C'">
                                    {{"BHD" | translate}} {{ item?.transactionAmount | amountFormatter }}
                                </div>

                                <div class="font-400 font-size-12px line-h-12 color-base-1800 text-align-right">
                                    {{ item?.runningBalance }}
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>
            </ng-container>

        </div>
        <!-- Empty state non islamic -->
        <ng-container>
            <!-- *ngIf="this.serviceType === 'Conventional'" -->
            <!-- *ngIf="this.loanDetail?.length===0" -->
            <grid-row class="justify-content-center align-item-center h-100vh-80"
                *ngIf="loanDetail !== undefined && loanDetail?.length==0">
                <grid-col col="4" ipad="12">
                    <div class="text-align-center">
                        <ng-icon iconClass="icon-loan-dashboard-big" width="120" height="120"></ng-icon>
                    </div>
                    <div *ngIf="this.serviceType === 'Conventional'"
                        class="font-400 font-size-20px line-h-25 color-base-700 text-align-center mt-30">
                        {{"YouDontHaveAnyActiveLoanyet" | translate }}
                    </div>
                    <div *ngIf="this.serviceType === 'Islamic'"
                        class="font-400 font-size-20px line-h-25 color-base-700 text-align-center mt-30">
                        {{"YouDontHaveAnyActiveFinanceyet" | translate }}
                    </div>
                    <div *ngIf="this.serviceType === 'Conventional'"
                        class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                        {{"AtBahrainCredit" | translate }}
                    </div>
                    <div *ngIf="this.serviceType === 'Islamic'"
                        class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                        {{"AtBahrainCreditFinance" | translate }}
                    </div>
                </grid-col>
            </grid-row>
        </ng-container>


        <!-- Empty state for islamic start-->
        <!-- <ng-container *ngIf="this.serviceType === 'Islamic'">
        <grid-row class="justify-content-center align-item-center h-100vh-80" >
            <grid-col col="4" ipad="12">
                <div class="text-align-center">
                 <ng-icon iconClass="icon-creditcard-not-available" width="307" height="230"></ng-icon>
                </div>
                <div class="font-400 font-size-20px line-h-25 color-base-700 text-align-center">
                    {{"Creditcardarenotavailable" | translate }}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-700 text-align-center mt-10">
                    {{"Cardservicesare" | translate }}
                </div>

                <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-30">
                    {{"Wouldyouliketoswitch" | translate }}
                </div>
                <grid-row class="justify-content-center mt-30">
                    <grid-col col="12">
                        <button class="btn-dft">
                            {{ "switchtoSahelservices" | translate }}
                        </button>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
        </ng-container> -->

        <!-- Empty state for islamic end-->



        <!-- old work -->
        <!-- <grid-row class="justify-content-center align-item-center h-100 mt-50" *ngIf="this.ViewGroupTransaction">
            <grid-col col="4">
                <div class="text-align-center">
                    <ng-icon iconClass="icon-loan-dashboard-big" width="120" height="120"></ng-icon>
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                    {{"Youhaventmadeanypaymentonyourloan" | translate }}
                </div>
            </grid-col>
        </grid-row> -->
    </div>
</div>

<!-- View Laon statement Modal Open -->

<!-- <modal modalID="5" modalClass="min-height-400" [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="CONFIRM" (doneButton)="showModal(6)" [whiteButtonStatus]="true" whiteButtonText="CANCEL">
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
        {{ "PleaseViewStatement" | translate }}
    </div>
    <div class="form-group mt-30">
        <label>{{"PleaseViewStatement" | translate}}</label>
        <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedMonth"
            [dropDownData]="this.Monthlist" (itemselected)="onMonthChange($event)">
            {{this.selectedMonth}}
        </drop-down-list>
    </div>
</modal> -->
<!-- View Card statement Modal -->
<!-- <modal modalID="5" modalClass="min-height-300"  [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="CONFIRM" (doneButton)="ViewStatement(6)"  [whiteButtonStatus]="true" whiteButtonText="CANCEL">
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
        {{ "PleaseViewStatement" | translate }}
    </div>
    <div class="form-group mt-30">
        <label>{{"PleaseViewStatement" | translate}}</label>
        <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedMonth"
            [dropDownData]="this.Monthlist" (itemselected)="onMonthChange($event)">
            {{this.selectedMonth}}
        </drop-down-list>
    </div>
</modal> -->


<!-- Month statement Modal Open -->
<!-- <modal modalID="6" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Download">
    <div class="font-600 font-size-20px line-h-40 color-base-1300">
        {{ "October" | translate }}
    </div>
    <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1500">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1600">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row>
</modal> -->

<modal modalID="6" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Download"
    (doneButton)="DownloadStatement()">
    <div *ngFor="let items of ViewStatementList">
        <div class="font-600 font-size-20px line-h-40 color-base-1300 mt-10">
            {{ items?.label }}
        </div>
        <div *ngFor="let item of items?.cardTransactions">
            <grid-row class="mt-8 justify-content-between">
                <grid-col col="8">
                    <div class="font-400 font-size-12px line-h-20 color-base-1500">
                        {{item?.transactionDescription}}
                    </div>
                    <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-5 text-align-left">
                        {{item?.transactionDate}}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-20 color-error" *ngIf="item?.debitCreditIndicator=='D'">
                        - {{item?.transactionCurrency}} {{item?.transactionAmount}}
                    </div>
                    <div class="font-600 font-size-14px line-h-20 color-success"
                        *ngIf="item?.debitCreditIndicator=='C'">
                        {{item?.transactionCurrency}} {{item?.transactionAmount}}
                    </div>
                    <!-- <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                        GBP 140.71
                    </div> -->
                </grid-col>
            </grid-row>

        </div>
    </div>

    <!-- <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1500">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1600">
                {{"Tesco" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                30/10 - 8:32PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error">
                - {{"BHD" | translate}} 64.205
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                GBP 140.71
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"PayCard" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 11:08AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-success text-align-right">
                - {{"BHD" | translate}} 64.205
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-20 mb-8">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"FoodWorldWLL" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                28/10 - 10:28AM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 100.000
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                5270 17•• •••• 4924
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-20">
        <grid-col col="auto">
            <div class=" font-400 font-size-12px line-h-20 color-base-1500 text-align-left">
                {{"MidwaySupermarket" | translate}}
            </div>
            <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-left">
                24/10 - 2:28PM
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-error text-align-right">
                - {{"BHD" | translate}} 20.000
            </div>
        </grid-col>
    </grid-row> -->
</modal>

<modal modalID="7" modalClass="min-height-300" [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="CONFIRM" (doneButton)="paymenthistory()" [whiteButtonStatus]="true" whiteButtonText="CANCEL">
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
        {{ "PleaseViewStatement" | translate }}
    </div>
    <div class="form-group mt-30">
        <label>{{"PleaseViewStatement" | translate}}</label>
        <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedMonth"
            [dropDownData]="this.Monthlist" (itemselected)="onMonthChange($event)">
            {{ this.selectedMonth}}
        </drop-down-list>
    </div>
</modal>

<!-- Transaction DETAILS Modal -->

<modal modalID="10" [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="Share Receipt" (doneButton)="DownloadStatement()">
    <div class="text-align-center">
        <div class="font-400 font-size-14px line-h-20 color-base-1800">
            <!-- {{"OlympiaSports" | translate}} -->
            {{SelectedtransactionDetail?.transactionDescription}}
        </div>
        <div class="font-500 font-size-24px line-h-32 color-success"
            *ngIf="SelectedtransactionDetail?.debitCreditIndicator =='C'">
            {{"BHD" | translate}} {{SelectedtransactionDetail?.transactionAmount |amountFormatter}}
        </div>
        <div class="font-500 font-size-24px line-h-32 color-error"
            *ngIf="SelectedtransactionDetail?.debitCreditIndicator =='D'">
            - {{"BHD" | translate}} {{SelectedtransactionDetail?.transactionAmount|amountFormatter}}
        </div>
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-1800 mt-24 letter-spacing-1">
        {{"TransactionDetails" | translate}}
    </div>
    <grid-row class="justify-content-between mt-24">
        <!-- <grid-col col="auto">
        <div class="font-400 font-size-12px line-h-20 color-base-1800">
            {{"Balance" | translate}}
        </div>
    </grid-col>
    <grid-col col="auto">
        <div class="font-500 font-size-14px line-h-20 color-base-1300">
            {{"BHD" | translate}} 1,240.54
        </div>
    </grid-col> -->
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"RefiD" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.referenceNumber}}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Date" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300"
                *ngIf="SelectedtransactionDetail?.transactionDate">
                <!-- {{SelectedtransactionDetail?.transactionDate}} -->
                {{ transactionDateOnly }}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Time" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                <!-- {{SelectedtransactionDetail?.transactionDate}} -->
                {{ transactionTimeOnly }}
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"Runningbalance" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.runningBalance}}
            </div>
        </grid-col>
    </grid-row>

    <!-- <grid-row class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"vat" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.vat}}
            </div>
        </grid-col>
    </grid-row> -->
    <grid-row *ngIf="SelectedtransactionDetail?.vat" class="justify-content-between mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800">
                {{"vat" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-500 font-size-14px line-h-20 color-base-1300">
                {{SelectedtransactionDetail?.vat}}
            </div>
        </grid-col>
    </grid-row>
</modal>

<!-- Request Letter -->
<modal modalID="11" [events]="modalObservable.asObservable()" [backdropDismiss]="false" [whiteButtonStatus]="true"
    whiteButtonText="CANCEL" modalDoneButtonStatus="false">
    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
        {{"RequestLetter" | translate}}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        *ngFor="let item of this.LettersList" (click)="requestLetterSelectedItem(item)">
        {{item.desc_eng}}
    </div>
    <!-- <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="payLoanSuccess()">
        {{ "LoanLetter" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="payLoanSuccess()">
        {{ "OutstandingBalanceLetter" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="payLoanSuccess()">
        {{ "StatementAccount" | translate }}
    </div>
    <div class="link border-bottom border-color-2100 pb-24 pt-24 font-400 font-size-14px color-base-1300"
        (click)="showModal(12,'')">
        {{ "SemiAnnualStatement" | translate }}
    </div>
    <div class="link pb-24 pt-24 font-400 font-size-14px color-base-1300" (click)="cardReplacementSuccess()">
        {{ "ClearanceLetter" | translate }}
    </div> -->
</modal>


<!-- Change Card -->
<modal modalID="12" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONTINUE"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="CheckStatus()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-email-black-big" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"PaymentContinue" | translate}}
        </div>
        <!-- <div class="color-base-400  font-size-14px line-h-25 mt-10">
            <span>
                {{ "PaymentsOf" | translate}}
            </span>
            <strong class="color-base-1300">
                {{"BHD" | translate}} {{this.TotalAmount}} (BHD {{this.PaymentDetail?.charges}} , VAT BHD {{this.PaymentDetail?.vat}})
            </strong>
            <span>
                {{ "AreRequiredLetter" | translate}}
            </span>
        </div> -->
        <div class="color-base-400  font-size-14px line-h-25 mt-10">
            {{"PaymentsRequiredLetter" | translate}}
        </div>
    </div>
</modal>